import main from './main.vue'
const commonNewDataPicker= {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonNewDataPicker